import { Callout } from '@/components/ui/callout';
import { useTranslation } from '@/hooks/useTranslation';
import { useLabeling } from '../../context/useLabeling';
import { useKeyboardShortcuts } from '../../hooks/useKeyboardShortcuts';
import { ImageViewer } from './ImageViewer';
import { LabelPanel } from './LabelPanel';
import { SeriesPanel } from './SeriesPanel';

export function FocusMode() {
  const { t } = useTranslation();
  const { mode, current, stats, applyLabel, undo, goPrev, goNext, classifyWithAi } = useLabeling();

  useKeyboardShortcuts(
    {
      onLabel1: () => current && applyLabel(current.key, 'ok'),
      onLabel2: () => current && applyLabel(current.key, 'worn'),
      onLabel3: () => current && applyLabel(current.key, 'unreadable'),
      onUndo: undo,
      onPrev: goPrev,
      onNext: goNext,
      onClassify: () => current && void classifyWithAi(current.key),
    },
    mode === 'focus'
  );

  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      {stats.done === stats.total && stats.total > 0 && (
        <Callout tone="success" className="flex-shrink-0">
          {t('labeling.complete.banner')}
        </Callout>
      )}

      {/* One row bounded to the available height: without it the row grows to the tallest
          column and the bottom of the others is cut off on short windows. */}
      <div className="flex-1 overflow-hidden grid grid-cols-[210px_1fr_256px] grid-rows-[minmax(0,1fr)]">
        <SeriesPanel />
        <div className="h-full p-3 flex flex-col overflow-hidden">
          <ImageViewer />
        </div>
        <LabelPanel />
      </div>
    </div>
  );
}
